import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "./apiClient";

/**
 * Hook for liking/unliking photos
 * Handles both like and dislike operations
 */
export const usePhotoActions = () => {
  const queryClient = useQueryClient();

  const likePhoto = useMutation({
    mutationFn: async (photoId) => {
      const response = await apiClient.post(
        `/api/PhotoLibrary/${photoId}/like`
      );
      return response.data;
    },
    onSuccess: () => {
      // Invalidate photo queries to refresh data
      queryClient.invalidateQueries({ queryKey: ["photos"] });
      queryClient.invalidateQueries({ queryKey: ["photo"] });
    },
    onError: (error) => {
      console.error("Error liking photo:", error);
    },
  });

  const dislikePhoto = useMutation({
    mutationFn: async (photoId) => {
      const response = await apiClient.post(
        `/api/PhotoLibrary/${photoId}/dislike`
      );
      return response.data;
    },
    onSuccess: () => {
      // Invalidate photo queries to refresh data
      queryClient.invalidateQueries({ queryKey: ["photos"] });
      queryClient.invalidateQueries({ queryKey: ["photo"] });
    },
    onError: (error) => {
      console.error("Error disliking photo:", error);
    },
  });

  return {
    likePhoto,
    dislikePhoto,
  };
};
